module.exports = __webpack_public_path__ + "img/linkedIn.228d3999.svg";